import React from 'react';

export const PrevPageIcon = () => (
  <svg width="10px" height="15px" viewBox="0 0 10 15">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-415.000000, -2441.000000)" fill="#FFFFFF">
        <g transform="translate(132.000000, 2405.000000)">
          <g transform="translate(268.000000, 24.000000)">
            <g transform="translate(20.000000, 20.000000) rotate(180.000000) translate(-20.000000, -20.000000) ">
              <polygon
                transform="translate(20.000000, 20.500000) rotate(-90.000000) translate(-20.000000, -20.500000) "
                points="20.0011667 21.5615385 14.6473333 16 13 17.711336 20.0011667 25 27 17.711336 25.3561667 16"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
